export default __webpack_public_path__ + "static/media/components.198de238.png";